import { useEffect, useState } from "react";
import { api } from "@/api";

let cache = null;

export function useTaxonomy() {
  const [tax, setTax] = useState(cache || { categories: [], materials: [], styles: [] });
  useEffect(() => {
    if (cache) { return; }
    api.get("/taxonomy").then(({ data }) => { cache = data; setTax(data); }).catch(() => {});
  }, []);
  return tax;
}
